import { Badge, BadgeProps } from "@chakra-ui/react";

type LevelBadgeProps = {
  level?: number;
  size?: "sm" | "md";
} & BadgeProps;

const LevelBadge = ({ level, size = "md", ...rest }: LevelBadgeProps) =>
  level !== 0 ? (
    <Badge
      borderRadius="full"
      fontWeight="semibold"
      bg={level === undefined ? "bright.700" : "secondary.500"}
      color="white"
      px="1.5"
      fontSize={size === "sm" ? "0.625rem" : undefined}
      {...rest}
    >
      {level === undefined ? `lvl–` : `lvl${level}`}
    </Badge>
  ) : null;

export default LevelBadge;
